import { render, staticRenderFns } from "./market-money.vue?vue&type=template&id=75070b96"
import script from "./market-money.vue?vue&type=script&lang=js"
export * from "./market-money.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports